import { Button } from 'reactstrap'
import { primary_color } from '../../../../Helper/uiHelper'
import { useEffect, useState } from 'react'
import { AvForm } from 'availity-reactstrap-validation'
import Select from '../../../../CMSComponent/Forms/Fields/select'
import { request } from '../../../../Redux/Sagas/requests/api'
import { useDispatch, useSelector } from 'react-redux'
import { isSuccessResponse } from '../../../../helper'
import { fetchUpdateApiData } from '../../../../Redux/Reducers/CMS'



const AddUserGroupDropdown = ({ gridRelatedData }) => {
  const currentRow = useSelector((state) => state.CMS.currentRow)
  const dispatch = useDispatch()

  const [fieldData, setFieldData] = useState()
  const [selectedValue, setSelectedValue] = useState()

  useEffect(() => {
    const grid_id = gridRelatedData?.tableGrid?.main_grid?.id
    request('get-grid-form', 'POST', { grid_id }).then((res) => {
      const field = res?.data?.[0]?.component_call_fields?.find((item) => item?.field_id === 'user_group_id')
      if (field) {
        setFieldData(field)
      }
    })
  }, [])

  const onAddData = () => {
    let payload = {
      is_nested: true,
      parent_table: 'query_types',
      parent_table_row_id: currentRow?.[0]?.id,
      data: {
        user_groups: selectedValue,
      },
    }
    request('raise-ticket/link-querytype-usergroup', 'POST', payload).then((res) => {
      if (isSuccessResponse(res, 'User group added successfully!')) {
        dispatch(fetchUpdateApiData())
        setSelectedValue()
      }
    })
  }
  if (!fieldData) return
  return (
    <AvForm style={{ display: 'flex' }}>
      <div style={{ flex: 1 }}>
        <Select data={fieldData} onChangeAction={(a, b, c, value, label) => setSelectedValue(value)} value={selectedValue} />
      </div>
      <div>
        <Button
          style={{ background: primary_color, marginTop: '2rem', marginLeft: '1rem' }}
          onClick={() => onAddData()}
          disabled={selectedValue?.length > 0 ? false : true}>
          Add
        </Button>
      </div>
    </AvForm>
  )
}

export default AddUserGroupDropdown
